import React from 'react';
import styled from 'styled-components';
import Refresh from './Refresh';

export const StyledButtonContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin: 0.5em 0 0.5em 0;
  flex-flow: row wrap;
  gap: 40px;
  padding-top: 27px;
  @media (orientation: portrait) and (max-width: 1000px) {
    justify-content: end;
  }

  .backButton {
    width: 9em;
    height: 2em;
  }
  .btn-register,
  .btn-continue {
    width: 9em;
    height: 2em;
  }
  .buttons {
    display: flex;
    gap: 20px;
    flex-flow: row wrap;
    @media (orientation: portrait) and (max-width: 1000px) {
      justify-content: end;
    }
  }
  .refreshButton {
    align-self: center;
  }
`;

const ButtonContainer = ({ children, style }) => {
  return (
    <StyledButtonContainer style={style} className="btn-container">
      <div className={'buttons'}>{children}</div>
      <Refresh />
    </StyledButtonContainer>
  );
};

export default ButtonContainer;
